import { z } from 'zod'

// Виды сущностей универсального поиска. transcript — совпадение в сказанном на
// встрече (id встречи-владельца); company/project/tag своих страниц не имеют —
// переход ведёт в список встреч с фильтром (url считает бэк).
export const SearchKindSchema = z.enum(['meeting', 'transcript', 'company', 'project', 'tag'])
export type SearchKind = z.infer<typeof SearchKindSchema>

export const MatchLocationSchema = z.enum(['title', 'description', 'transcript', 'name', 'tag'])
export type MatchLocation = z.infer<typeof MatchLocationSchema>

export const SearchHitSchema = z.object({
  kind: SearchKindSchema,
  entityId: z.string(),
  label: z.string(),
  snippet: z.string().optional(),
  matchedIn: MatchLocationSchema,
  score: z.number(),
  url: z.string(),
  meetingId: z.string().optional(),
})
export type SearchHit = z.infer<typeof SearchHitSchema>

// Навигационная цель хита в терминах роутера. Бэк отдаёт готовый url, но
// TanStack Router строит переход из пути + search-объекта, поэтому раскладываем:
// у справочных видов своих страниц нет — уводим в список встреч с фильтром.
export function hitTarget(
  hit: SearchHit,
):
  | { to: '/meetings/$id'; params: { id: string } }
  | { to: '/meetings'; search: { company?: string; project?: string; tag?: string } } {
  switch (hit.kind) {
    case 'company':
      return { to: '/meetings', search: { company: hit.entityId } }
    case 'project':
      return { to: '/meetings', search: { project: hit.entityId } }
    case 'tag':
      return { to: '/meetings', search: { tag: hit.label } }
    default:
      // meeting и transcript ведут в карточку встречи (у расшифровки entityId —
      // id встречи-владельца).
      return { to: '/meetings/$id', params: { id: hit.entityId } }
  }
}
